import { render, staticRenderFns } from "./apiConfig.vue?vue&type=template&id=b0f199f6&"
import script from "./apiConfig.vue?vue&type=script&lang=js&"
export * from "./apiConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0f199f6')) {
      api.createRecord('b0f199f6', component.options)
    } else {
      api.reload('b0f199f6', component.options)
    }
    module.hot.accept("./apiConfig.vue?vue&type=template&id=b0f199f6&", function () {
      api.rerender('b0f199f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/formSys/apiConfig.vue"
export default component.exports